/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Baseclass for menu items
 * @class MenuItemBase
 * @classdesc The structure for the Items of a menu
 * @author insite-gmbh
 */
class MenuItemBase {
    constructor(id, text = "", action = "", childs = [], parent = null) {
        this.id = id;
        this.text = text;
        this.action = action;
        this.childs = childs;
        this.parent = parent;
        this.isDisabled = false;
        this.isSelected = false;
        if (this.childs != null) {
            try {
                this.childs.forEach(c => c.parent = this);
            }
            catch (error) { }
        }
    }
    /**
     * call this action on select
    * @method selectAction
     */
    selectAction() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.parent != null)
                return yield this.provider.applySelectAction(this);
            return true;
        });
    }
}
exports.MenuItemBase = MenuItemBase;
